import axios from 'axios';

export const sanitizeString = (string) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  const reg = /[&<>"'/]/gi;
  return string.replace(reg, (match) => map[match]);
};

export const isEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
  );
}

export function sanitizeURL(url) {
  let finalUrl = url;

  finalUrl = finalUrl.startsWith('/') ? finalUrl.substring(1) : finalUrl;

  finalUrl = finalUrl.endsWith('/') ? finalUrl.slice(0, -1) : finalUrl;

  finalUrl = finalUrl.endsWith('?') ? finalUrl.slice(0, -1) : finalUrl;

  return finalUrl;
}

export function getEnvironment() {
  const appName = process.env.HEROKU_APP_NAME;

  return appName ? 'development' : process.env.ENVIRONMENT;
}

export function getRawURL(url, baseURL) {
  // Remove base URL
  const parsedURL = url.replace(`${baseURL}/`, '');

  return (
    parsedURL
      .replace(/\/\d+/g, '/:id')
      .replace(/=[\w\W\d]+/g, '=:id')
      // Custom rules
      .replace(/\/get-num-questions\/[\w\W\d]+/g, '/get-num-questions/:id')
      .replace(
        /\/company_profiles\/[^?][\w\W\d]+/g,
        '/company_profiles/:company',
      )
  );
}

export function getGeneric(req, res) {
  const pathString = req.originalUrl.toString();
  const isReplica = !!pathString.includes('/replica/');
  const query = isReplica
    ? pathString.replace('/api/replica/', '')
    : pathString.replace('/api/', '');
  const url = isReplica
    ? process.env.BASE_REPLICA_URL
      ? process.env.BASE_REPLICA_URL
      : process.env.BASE_URL
    : process.env.BASE_URL;

  axios
    .get(`${url}${query}`)
    .then((response) => {
      res.send(response.data);
    })
    .catch(() => {
      res.send({});
    });
}

export function getEnvVars() {
  const asJson = (value) => JSON.stringify(value ?? null);

  return {
    NODE_ENV: process.env.NODE_ENV,
    activeEnvironment: asJson(process.env.ENVIRONMENT),
    baseURL: asJson(process.env.BASE_URL),
    googleMapsAPIKey: asJson(process.env.GOOGLE_MAPS_API_KEY),
    hiringURL: asJson(process.env.HIRING_URL),
    integrationsURL: asJson(process.env.INTEGRATIONS_URL),
    IpsFromIndeed: asJson(process.env.IPS_FROM_INDEED),
    ldClientID: asJson(process.env.LAUNCHDARKLY_CLIENT_ID),
    maptilerAPIKey: asJson(process.env.MAPTILER_API_KEY),
    releaseVersion: asJson(process.env.RELEASE_VERSION),
    turnstileSiteKey: asJson(process.env.TURNSTILE_SITE_KEY),
  };
}

export const logApiError = (message, error) => {
  const errorDetails = {
    message: `[ERROR] ${message}`,
    developer_message:
      error &&
      error.response &&
      error.response.data &&
      error.response.data.developer_message,
    host: error.request && error.request.host,
    path: error.request && error.request.path,
    status: error.response && error.response.status,
    statusText: error.response && error.response.statusText,
  };
  console.log(JSON.stringify(errorDetails, null, 2));
};

/* getCredentialingToken */
/* -------------------------------------------------------------------------
   The verification flow is anonymous — the applicant arrives from an emailed
   link with no session — so person_id in the URL was the only thing naming
   them, and it is derived from their email address (BDRK-3928). python_api
   now signs that link with a short-lived token bound to the person, which the
   credentialing endpoints check against the person_id being requested.

   Read here rather than threaded through the component tree because both
   entry points into this flow (the applicant's emailed link and the recruiter
   link built by apploi-main) carry it the same way: on the URL.
   ------------------------------------------------------------------------- */
export const getCredentialingToken = () => {
  /* Bolivar renders server-side; there is no location to read there. */
  if (typeof window === 'undefined' || !window.location) {
    return null;
  }

  return new URLSearchParams(window.location.search).get('credentialing_token');
};
